import React from "react";
import styled from "styled-components";
import ServiceCard from "./ServiceCard";
import contentImage from "../images/content-img.png";
import SendMsg from "./SendMsg";

const Main = styled.p`
  color: #514e4e;
  font-family: "Syne";
  font-size: 40px;
  font-weight: 700;
  margin-bottom: 56px;

  span {
    color: #f7cb57;
    font-family: "Syne";
  }
  @media (max-width: 1024px) {
    font-size: 2rem;
    margin-bottom: 2rem;
  }
`;

const ContentContainer = styled.div`
  padding: 5rem 4rem 0rem;
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) and (max-width: 819px) {
    padding: 40px 48px 0px;
  }

  @media (max-width: 767px) {
    padding: 40px 16px 0px;
  }
`;

const ContentRow = styled.div`
  display: none;

  @media (min-width: 1030px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 32px;
    margin-bottom: 32px;
  }
`;

const ContentRowMobile = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 32px;
    margin-top: 2rem;
    flex-direction: column;
  }
`;

const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const Conclusion = styled.p`
  font-size: 16px;
  line-height: 24px;
  text-align: justify;
  color: #514e4e;
`;

const ContentImgWrapper = styled.div`
  width: 600px;
  padding: 1rem 4rem;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7cb57;
  border-radius: 30px;

  @media (max-width: 1024px) {
    width: 100%;
    height: 400px;
  }
`;

const ContentImg = styled.img`
  width: 540px;
  height: 100%;
  object-fit: contain;

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 64px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 0px;
  }
`;
const ServicesContentContainer = ({
  contentData,
  conclusion,
  title,
  includeTxt,
}) => {
  return (
    <ContentContainer>
      <Main>
        <h5>
          Our <span>{title}</span>
        </h5>
        <h5>{includeTxt && includeTxt} include:</h5>
      </Main>
      <ContentRow>
        {contentData?.slice(0, 3).map((content) => (
          <ServiceCard key={content.id} content={content} />
        ))}
      </ContentRow>
      <ContentWrapper>
        <ContentImgWrapper>
          <ContentImg src={contentImage} alt="content-img" />
        </ContentImgWrapper>
        <ContentColumn>
          <ContentRowMobile>
            {contentData?.slice(0, 3).map((content) => (
              <ServiceCard key={content.id} content={content} />
            ))}
          </ContentRowMobile>
          {contentData?.slice(3, 7).map((content) => (
            <ServiceCard key={content.id} content={content} />
          ))}
          <Conclusion>{conclusion}</Conclusion>
        </ContentColumn>
      </ContentWrapper>
      <SendMsg />
    </ContentContainer>
  );
};

export default ServicesContentContainer;
